import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import VSelect from 'vuetify/lib/components/VSelect'
import VTextField from 'vuetify/lib/components/VTextField'
import { Intersect, Resize } from 'vuetify/lib/directives'

Vue.use(Vuetify, {
  components: { VSelect, VTextField }
})
Vue.directive('intersect', Intersect)
Vue.directive('resize', Resize)

export default new Vuetify({
  options: { customProperties: true }, // allows to access theme color such as primary in css / scss
  theme: {
    themes: {
      light: {
        primary: '#22AFED'
      },
      dark: {
        primary: '#22AFED'
      }
    }
  }
})
